import React, { useState } from 'react';
import styles from './Login.module.scss'; 
import Menu from '../Shared/Menu'
import { connect } from 'react-redux'
import { logIn, fetchAuth as fetchNoAuth } from '../../actions'
import { Input , Button, message } from 'antd';
import { Link } from 'react-router-dom'
import Logo from '../../images/Logo.png'; 

function Login(props)  {
    const sys = 'sysadm';
    const [user, setUser] = useState('');
    const [pass, setPass] = useState('');
    const [loading, setLoading] = useState(false);
    
    const handleSubmit = (event) => {
        login();
        event.preventDefault();
    }

     const login = () => {
        setLoading(true);

        props.fetchNoAuth().post('/entrar', { user, pass, sys, versao: 2 })
        .then(function ({data}) {
            setLoading(false);
            props.logIn({ user: data.userName, tokenId: data.tokenId, refreshToken: data.refreshToken });
            props.history.push('/');
        })
        .catch(function (error) {
            console.log(error);
            setLoading(false);
            message.error('Usuário/Senha inválidos');
        });
      }

    return(
        <form onSubmit={handleSubmit}>
            <div className={styles.main}>
                <div style={{textAlign:'center'}}>
                    <img src={Logo} alt="Logo" style={{maxHeight: '80px', marginBottom:20}}/>
                </div>
                <div>
                    <input type="text" placeholder="Usuário" className="form-control" value={user} onChange={e => setUser(e.target.value)} />
                </div>
                <div style={{marginTop:20}}>
                    <input type="password" placeholder="Senha" className="form-control" value={pass} onChange={e => setPass(e.target.value)} />
                </div>
                <div style={{marginTop:20}}>
                    <Button htmlType="submit" className={styles.btnLogin} type="primary" loading={loading} size="large">Entrar</Button>
                </div>
            </div>   
        </form>         
    )
}

export default connect(null, { logIn, fetchNoAuth })(Login);